import { GeneralViewNames } from '../side-bar/side-bar.type';

type ChatHistory = {
  id: string;
  last_accessed: string;
  description: string;
  messages: Message[];
};

type Message = {
  content: string;
  role: string;
  timestamp: string;
};

enum FloraSupportedObjectTypes {
  Portfolio = 'portfolio',
  Project = 'project',
  Subproject = 'subproject',
  Initiative = 'initiative',
  WorkPeriod = 'work_period',
  Dashboard = 'dashboard',
}

type FloraContextObject = {
  type: FloraSupportedObjectTypes;
  id: string;
  name: string;
};

type FloraContextualInfo = {
  currentModule: GeneralViewNames;
  currentObjects: FloraContextObject[];
  startDate: string | null;
  endDate: string | null;
};

export { FloraSupportedObjectTypes };
export type { ChatHistory, FloraContextObject, FloraContextualInfo };
